import { FLAGS, type FlagName } from "src/posthog/flags";
import { usePosthog, useFeatureFlag } from "src/contexts/posthog.context";

// /dev/flags — dev-only UI for flipping PostHog feature flags locally.
// Router.tsx only mounts this route when authMode !== "prod", so the
// component's own `setFlag` call (unsupported in PosthogSDKReal) is never
// reached in production. In local mode, PosthogSDKWrapper stores flags in
// localStorage and fires its `onFeatureFlags` handlers, so every
// `useFeatureFlag` consumer in the app re-renders as you toggle.
export function DevFlagsScreen() {
  return (
    <div className="w-screen min-h-screen bg-neutral-2 p-8 font-mono">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-xl mb-2">Dev Flags</h1>
        <p className="text-sm text-neutral-6 mb-6">
          Local-mode flag toggles. Writes to localStorage. In future staging
          environments these will write to PostHog instead.
        </p>
        <div className="bg-white rounded-md shadow-sm divide-y">
          {Object.values(FLAGS).map((flag) => (
            <FlagRow key={flag} name={flag} />
          ))}
        </div>
      </div>
    </div>
  );
}

function FlagRow({ name }: { name: FlagName }) {
  const posthog = usePosthog();
  const enabled = useFeatureFlag(name);
  return (
    <button
      type="button"
      onClick={() => posthog.setFlag(name, !enabled)}
      className="w-full flex items-center justify-between px-4 py-3 hover:bg-neutral-2 text-left"
    >
      <span className="text-sm">{name}</span>
      <span
        className={
          enabled
            ? "text-xs font-semibold uppercase tracking-wide text-green-700"
            : "text-xs font-semibold uppercase tracking-wide text-neutral-5"
        }
      >
        {enabled ? "ON" : "OFF"}
      </span>
    </button>
  );
}
